import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { AlertService } from '../alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { CountryActions } from './country.actions';
import { CountryService } from '../../services/country.service';
import { Country } from '../../models/country.model';
import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';

export class CountryStateModel {
  public countries: Country[];
  public error: string;
}

const defaults = {
  countries: [],
  error: ''
};

@State<CountryStateModel>({
  name: 'country',
  defaults
})
@Injectable()
export class CountryState {

  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private countryService: CountryService
  ) { }

  @Action(CountryActions.GetCountries)
  getCountries(ctx: StateContext<CountryStateModel>, { }: CountryActions.GetCountries) {
    return this.countryService.getCountries().subscribe({
      next: (countries: Country[]) => {
        ctx.dispatch(new CountryActions.GetCountriesSuccess(countries));
      },
      error: (error) => {
        ctx.dispatch(new CountryActions.GetCountriesFail(error));
      }
    });
  }

  @Action(CountryActions.GetCountriesSuccess)
  getCountriesSuccess(ctx: StateContext<CountryStateModel>, { countries }: CountryActions.GetCountriesSuccess) {
    ctx.patchState({
      countries: countries
    });
  }

  @Action(CountryActions.GetCountriesFail)
  getCountriesFail(ctx: StateContext<CountryStateModel>, { error }: CountryActions.GetCountriesFail) {
    ctx.patchState({
      error: error,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('countries.title');
  }
}
